












import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
@Component({
    components: {}
})
export default class popup extends Vue {
  @Prop() private text: any;
  ShutDown() {
      this.$emit('ShutDown')
  }
}
